// 韩漫网 Mock 数据 - 漫画列表
export interface Comic {
  id: number;
  title: string;
  author: string;
  cover: string;
  category: string;
  categorySlug: string;
  description: string;
  longDescription: string;
  status: string;
  updateDate: string;
  rating: number;
  views: number;
  chapters: number;
  tags: string[];
  featured: boolean;
  isNew: boolean;
  isHot: boolean;
}

export const categories = [
  { name: '热血', slug: 'rexue', icon: 'ri-fire-line' },
  { name: '爱情', slug: 'aiqing', icon: 'ri-heart-line' },
  { name: '冒险', slug: 'maoxian', icon: 'ri-compass-line' },
  { name: '奇幻', slug: 'qihuan', icon: 'ri-magic-line' },
  { name: '搞笑', slug: 'gaoxiao', icon: 'ri-emotion-laugh-line' },
  { name: '悬疑', slug: 'xuanyi', icon: 'ri-search-eye-line' },
];

export const comics: Comic[] = [
  {
    id: 1,
    title: '剑与魔法',
    author: '金泰亨',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20fantasy%20warrior%20holding%20a%20glowing%20sword%20in%20a%20magical%20battlefield%20with%20dramatic%20lighting%20and%20dynamic%20action%20pose%2C%20digital%20art%20style%2C%20vibrant%20colors%2C%20clean%20composition%20on%20simple%20dark%20background&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    category: '热血',
    categorySlug: 'rexue',
    description: '在剑与魔法的世界中，少年踏上成为最强剑士的冒险之旅！',
    longDescription: '在一个被剑与魔法支配的世界里，出身平凡的少年艾伦·格雷特意外觉醒了传说中的"剑之意志"。为了寻找失踪的师父，他踏上了成为最强剑士的冒险之旅。在这条充满危机与挑战的道路上，他结识了志同道合的伙伴，也遭遇了前所未有的强敌。剑与魔法的碰撞，友情与背叛的交织，一场跨越大陆的史诗冒险就此展开！每周五更新，热血不断！',
    status: '连载中',
    updateDate: '2026-08-03',
    rating: 9.5,
    views: 1285000,
    chapters: 156,
    tags: ['战斗', '成长', '奇幻'],
    featured: true,
    isNew: false,
    isHot: true,
  },
  {
    id: 2,
    title: '甜蜜陷阱',
    author: '李智恩',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20style%20illustration%20of%20a%20beautiful%20couple%20sharing%20a%20tender%20moment%20under%20cherry%20blossom%20trees%2C%20soft%20pastel%20colors%2C%20dreamy%20atmosphere%2C%20clean%20composition%20on%20simple%20light%20background&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    category: '爱情',
    categorySlug: 'aiqing',
    description: '当高冷总裁遇上职场新人，一场甜蜜的恋爱拉锯战就此展开！',
    longDescription: '初入职场的林小暖怎么也没想到，自己的直属上司竟然是大学时期暗恋过的学长韩宇辰。曾经那个阳光开朗的少年，如今已变成商界闻名的高冷总裁。更让人意外的是，这位冰山总裁似乎对自己有着特别的关注。是刻意的刁难，还是隐藏已久的心意？办公室里的每一次偶遇，都像是精心设计的甜蜜陷阱。每周二更新，心动不停！',
    status: '连载中',
    updateDate: '2026-08-02',
    rating: 9.3,
    views: 987000,
    chapters: 89,
    tags: ['职场', '甜宠', '治愈'],
    featured: true,
    isNew: false,
    isHot: true,
  },
  {
    id: 3,
    title: '深渊探险队',
    author: '朴志勋',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20adventure%20manhwa%20style%20illustration%20of%20explorers%20descending%20into%20a%20mysterious%20ancient%20ruin%20with%20glowing%20crystals%20and%20hidden%20treasures%2C%20dark%20atmospheric%20lighting%2C%20detailed%20background%2C%20clean%20composition&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    category: '冒险',
    categorySlug: 'maoxian',
    description: '一支冒险小队深入未知深渊，揭开被尘封千年的古老秘密！',
    longDescription: '在世界最深处，存在着一个被称为"深渊"的神秘领域。传说中，那里埋藏着失落文明的宝藏，也沉睡着不可名状的恐怖。经验丰富的探险家卡尔组织了一支精英小队，决心揭开深渊的秘密。然而，当他们越深入深渊，就越发现真相远比自己想象的更加震撼。深渊之下，究竟是财富还是毁灭？每周三更新，刺激不断！',
    status: '连载中',
    updateDate: '2026-07-30',
    rating: 9.1,
    views: 756000,
    chapters: 124,
    tags: ['探险', '解谜', '悬疑'],
    featured: false,
    isNew: false,
    isHot: true,
  },
  {
    id: 4,
    title: '仙界实习生',
    author: '崔秀英',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20comedy%20manhwa%20style%20illustration%20of%20a%20young%20office%20worker%20suddenly%20transported%20to%20a%20heavenly%20realm%20with%20floating%20palaces%20and%20divine%20beings%2C%20bright%20vibrant%20colors%2C%20humorous%20tone%2C%20clean%20composition&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    category: '奇幻',
    categorySlug: 'qihuan',
    description: '普通上班族意外进入仙界，开启爆笑又热血的修仙之旅！',
    longDescription: '996上班族张凡在一次加班途中，意外被一道闪电劈中，醒来后发现自己竟然穿越到了仙界！但这里的一切都和他想象中不一样——仙界竟然也有KPI考核，神仙们也要打卡上班？为了回到原来的世界，张凡不得不从最底层的"仙界实习生"做起，在工作之余偷偷修炼仙术。一场充满欢笑与感动的修仙之旅就此展开！每周四更新，笑料不断！',
    status: '连载中',
    updateDate: '2026-08-01',
    rating: 9.4,
    views: 1102000,
    chapters: 98,
    tags: ['修仙', '搞笑', '穿越'],
    featured: true,
    isNew: false,
    isHot: true,
  },
  {
    id: 5,
    title: '邻家女高',
    author: '尹智雅',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20comedy%20slice%20of%20life%20manhwa%20style%20illustration%20of%20high%20school%20girls%20laughing%20together%20in%20a%20classroom%2C%20bright%20cheerful%20colors%2C%20cute%20art%20style%2C%20clean%20composition%20on%20simple%20background&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    category: '搞笑',
    categorySlug: 'gaoxiao',
    description: '四个性格迥异的女高中生，每天上演令人捧腹的校园日常！',
    longDescription: '阳光中学高二（3）班，四个性格完全不同的女生——学霸班长、运动健将、追星少女和社恐画手，因为一次偶然的座位调整成为了前后桌。从此，她们的校园生活变得热闹非凡。考试前的临时抱佛脚、运动会上的意外状况、追星现场的疯狂应援、美术课上的灵魂画作……每一天都是满满的青春与欢笑。每周六更新，快乐每一天！',
    status: '连载中',
    updateDate: '2026-08-03',
    rating: 8.9,
    views: 623000,
    chapters: 67,
    tags: ['校园', '日常', '青春'],
    featured: false,
    isNew: true,
    isHot: false,
  },
  {
    id: 6,
    title: '消失的第七人',
    author: '姜东元',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20mystery%20thriller%20manhwa%20style%20illustration%20of%20a%20detective%20examining%20clues%20in%20a%20dimly%20lit%20room%20with%20a%20shadowy%20figure%20in%20the%20background%2C%20dark%20moody%20atmosphere%2C%20suspenseful%20tone%2C%20clean%20composition&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    category: '悬疑',
    categorySlug: 'xuanyi',
    description: '七人密室聚会，一人离奇消失，剩下的六人谁是真凶？',
    longDescription: '一个暴风雨的夜晚，七位大学好友相聚在深山中的别墅。第二天清晨，其中一人从密闭的房间中神秘消失，门窗完好无损，没有留下任何痕迹。警方介入调查后，发现剩下六人各自的证词都存在矛盾。每个人似乎都在隐瞒着什么。随着调查深入，尘封多年的秘密被逐一揭开，而真相远比所有人想象的更加黑暗。谁是凶手？又或者，根本就没有第七个人？每周日更新，烧脑推理！',
    status: '连载中',
    updateDate: '2026-07-28',
    rating: 9.6,
    views: 1340000,
    chapters: 45,
    tags: ['推理', '密室', '反转'],
    featured: true,
    isNew: false,
    isHot: true,
  },
  {
    id: 7,
    title: '末日生存法则',
    author: '孙贤宇',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20post%20apocalyptic%20action%20manhwa%20style%20illustration%20of%20a%20lone%20survivor%20in%20a%20ruined%20cityscape%20with%20dramatic%20sunset%20lighting%2C%20gritty%20art%20style%2C%20intense%20mood%2C%20clean%20composition&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    category: '热血',
    categorySlug: 'rexue',
    description: '末日降临，丧尸横行，看孤胆英雄如何绝境求生！',
    longDescription: '一场突如其来的病毒席卷全球，90%的人类变成了嗜血的丧尸。退伍特种兵赵铁柱在混乱中与家人失散，为了找到妻女，他独自踏上了穿越丧尸之城的危险旅程。食物短缺、人性的黑暗、变异丧尸的威胁……每走一步都可能是最后一步。但身为父亲的责任感支撑着他，让他在绝望中永不放弃。这是一场关于勇气、牺牲和希望的末日史诗。每周一更新，热血沸腾！',
    status: '已完结',
    updateDate: '2026-06-15',
    rating: 9.2,
    views: 2150000,
    chapters: 200,
    tags: ['丧尸', '生存', '动作'],
    featured: false,
    isNew: false,
    isHot: true,
  },
  {
    id: 8,
    title: '花店与猫',
    author: '朴素妍',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20romance%20slice%20of%20life%20manhwa%20style%20illustration%20of%20a%20flower%20shop%20owner%20with%20a%20cute%20cat%20in%20a%20cozy%20floral%20shop%2C%20warm%20soft%20lighting%2C%20gentle%20pastel%20colors%2C%20clean%20composition&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    category: '爱情',
    categorySlug: 'aiqing',
    description: '花店女老板与常来买花的温柔兽医，一段花香四溢的浪漫故事。',
    longDescription: '在首尔一条安静的小巷里，有一家名叫"春日呢喃"的花店。店主韩素熙是一个温柔的女孩，每天与花为伴，过着平静的生活。直到有一天，一位总是抱着受伤流浪猫来隔壁宠物医院的兽医金民俊走进了她的花店。他说，想买一束花送给刚出院的猫咪。从那以后，他成了花店的常客，而她，也开始期待每一次的相遇。花香与爱意，在这个春天悄然绽放。每周二更新，温暖入心！',
    status: '连载中',
    updateDate: '2026-08-04',
    rating: 9.0,
    views: 542000,
    chapters: 56,
    tags: ['治愈', '温馨', '日常'],
    featured: false,
    isNew: true,
    isHot: false,
  },
  {
    id: 9,
    title: '天选之子',
    author: '郑雨盛',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20adventure%20manhwa%20style%20illustration%20of%20a%20chosen%20hero%20with%20divine%20powers%20standing%20before%20a%20massive%20ancient%20gate%2C%20epic%20scale%2C%20bright%20celestial%20lighting%2C%20clean%20composition&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    category: '冒险',
    categorySlug: 'maoxian',
    description: '被选中的少年肩负拯救世界的使命，踏上充满试炼的旅程。',
    longDescription: '在远古预言中，每隔千年就会出现一位"天选之子"，他将在世界面临毁灭之时挺身而出。16岁的少年辰星在生日那天，发现自己手掌上浮现出神秘的星纹——这正是天选之子的印记。他被召唤到世界的尽头，那里有七道试炼之门等待着他。每通过一道门，他将获得一种神力；而失败，则意味着世界的终结。这是一个关于成长、勇气和担当的史诗故事。每周五更新，精彩无限！',
    status: '连载中',
    updateDate: '2026-07-31',
    rating: 9.3,
    views: 891000,
    chapters: 112,
    tags: ['少年', '成长', '史诗'],
    featured: false,
    isNew: false,
    isHot: true,
  },
  {
    id: 10,
    title: '美食猎人',
    author: '权志龙',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20food%20adventure%20comedy%20manhwa%20style%20illustration%20of%20a%20cheerful%20chef%20holding%20a%20giant%20delicious%20dish%20with%20exaggerated%20reaction%2C%20bright%20vibrant%20colors%2C%20dynamic%20food%20illustration%2C%20clean%20composition&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    category: '搞笑',
    categorySlug: 'gaoxiao',
    description: '为了寻找传说食谱而踏上旅程的美食家，每道菜都是一场冒险！',
    longDescription: '在这个世界，存在着一种被称为"传奇食谱"的神秘料理书。据说吃下按照传奇食谱制作的料理，就能获得不可思议的能力。天生拥有"神之舌"的少年美食家陈小明，为了寻找散落在世界各地的传奇食谱，踏上了美食冒险之旅。从街头小吃到宫廷御膳，从深山野味到深海珍馐，每一道菜背后都隐藏着一段故事。而最大的秘密，就藏在他自己的味觉之中。每周六更新，看得流口水！',
    status: '连载中',
    updateDate: '2026-07-29',
    rating: 8.8,
    views: 678000,
    chapters: 78,
    tags: ['美食', '冒险', '搞笑'],
    featured: false,
    isNew: true,
    isHot: false,
  },
  {
    id: 11,
    title: '镜中世界',
    author: '韩素希',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20psychological%20thriller%20manhwa%20style%20illustration%20of%20a%20person%20touching%20a%20mirror%20with%20their%20reflection%20showing%20a%20different%20expression%2C%20eerie%20atmosphere%2C%20dark%20moody%20tones%2C%20clean%20composition&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    category: '悬疑',
    categorySlug: 'xuanyi',
    description: '一面古老魔镜，映照出的不是自己，而是平行世界的另一个你。',
    longDescription: '古董收藏家苏晚晴在一次拍卖会上购得一面据称来自中世纪的古董镜子。当她第一次站在镜前，镜中映出的却不是自己的脸，而是一个看起来像是自己、但眼神截然不同的女人。更诡异的是，镜中的"她"开始与她对话，告诉她关于平行世界的秘密。随着交流的深入，苏晚晴发现镜中的自己正在一步步取代她在现实世界的位置。谁是真实，谁是镜像？当界线变得模糊，一切都将不可挽回。每周日更新，细思极恐！',
    status: '连载中',
    updateDate: '2026-08-02',
    rating: 9.4,
    views: 956000,
    chapters: 34,
    tags: ['心理', '平行世界', '恐怖'],
    featured: false,
    isNew: false,
    isHot: true,
  },
  {
    id: 12,
    title: '魔王陛下要打工',
    author: '安孝燮',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20comedy%20manhwa%20style%20illustration%20of%20a%20demon%20lord%20wearing%20a%20convenience%20store%20uniform%20looking%20embarrassed%2C%20bright%20humorous%20tone%2C%20vibrant%20colors%2C%20clean%20composition&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    category: '奇幻',
    categorySlug: 'qihuan',
    description: '被封印到人间的魔王为了生存，不得不在便利店打工？',
    longDescription: '魔界之主路西法，因为中了勇者的诡计被封印到了人间，不仅失去了大部分魔力，还被迫以人类的形态生活。更糟糕的是，为了支付房租和伙食费，这位曾经不可一世的魔王大人竟然要在便利店打工！收银台前手忙脚乱、面对顾客投诉手足无措、被店长训话时瑟瑟发抖……曾经让三界闻风丧胆的魔王，如今最大的敌人是月底的账单。而那位封印他的勇者，似乎就在隔壁的公司上班？每周四更新，笑到肚子疼！',
    status: '连载中',
    updateDate: '2026-08-04',
    rating: 9.1,
    views: 789000,
    chapters: 85,
    tags: ['反差萌', '搞笑', '日常'],
    featured: false,
    isNew: true,
    isHot: false,
  },
];

export const featuredComics = comics.filter(c => c.featured);
export const hotComics = comics.filter(c => c.isHot);
export const newComics = comics.filter(c => c.isNew);

export function getComicsByCategory(slug: string): Comic[] {
  const category = categories.find(c => c.slug === slug);
  if (!category) return [];
  return comics.filter(c => c.categorySlug === slug);
}

export function getComicById(id: number): Comic | undefined {
  return comics.find(c => c.id === id);
}

export function getRelatedComics(comic: Comic, limit: number = 4): Comic[] {
  return comics
    .filter(c => c.id !== comic.id && c.categorySlug === comic.categorySlug)
    .slice(0, limit);
}